(function () {
    // Cloud Run `best-sellers` service (moved off database-app-1 2026-09-23,
    // same /get-collection-best-seller-per-country contract). Ranks fresh ROW
    // shopper sales from company-data-hub. This call sends no country, and the
    // service - like database-app-1 before it - answers [] without one, so
    // every real badge comes from agb-priority-products.js.
    var BEST_SELLER_BASE_URL = 'https://best-sellers-432657747828.europe-west1.run.app';

    var _AGB_BS_DEBUG = false;
    var console = (_AGB_BS_DEBUG && typeof window !== 'undefined' && window.console)
        ? window.console
        : { log: function(){}, warn: function(){}, info: function(){}, error: function(){} };

    var SEEN_KEY = '__bestSellerCollectionsSeen';

    function _toast(msg) {
        if (window.AGB && window.AGB.utils && typeof window.AGB.utils.toast === 'function') {
            window.AGB.utils.toast(msg);
        }
    }

    function _seenIds() {
        try {
            var raw = sessionStorage.getItem(SEEN_KEY);
            var arr = raw ? JSON.parse(raw) : [];
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }

    function _haveSeen(id) {
        return _seenIds().indexOf(String(id)) !== -1;
    }

    function _markSeen(id) {
        try {
            var arr = _seenIds();
            if (arr.indexOf(String(id)) === -1) arr.push(String(id));
            sessionStorage.setItem(SEEN_KEY, JSON.stringify(arr));
        } catch (e) {}
    }

    function _geoipFlagsFromPanel() {
        try {
            var g = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.geoip;
            return {
                enabled: g && g.enabled === false ? '0' : '1',
                persist: g && g.persistToDatabase === false ? '0' : '1'
            };
        } catch (e) { return { enabled: '1', persist: '1' }; }
    }

    function _rankByFromPanel() {
        // Pulls rank_by from the main engine's loaded config. The engine
        // hydrates window.SE_Engine.config.bestSeller from the control
        // panel's BestSellerConfig. Defaults to 'revenue' (money
        // earned, last N months) when the config hasn't loaded yet -- matches
        // backend default. Possible values: 'qty', 'revenue'.
        try {
            var rb = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.bestSeller
                && window.SE_Engine.config.bestSeller.rankBy;
            if (rb === 'revenue' || rb === 'qty') return rb;
        } catch (e) { /* swallow */ }
        return 'revenue';
    }

    function _activationModeFromPanel() {
        // 'first-collection-only' (default): activate ONE best-seller for the
        //   first collection the shopper visits in their group's lifetime;
        //   no further activations until state is wiped.
        // 'every-collection': activate one best-seller per distinct
        //   collection the shopper visits (legacy behavior).
        try {
            var m = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.bestSeller
                && window.SE_Engine.config.bestSeller.activationMode;
            if (m === 'every-collection' || m === 'first-collection-only') return m;
        } catch (e) { /* swallow */ }
        return 'first-collection-only';
    }

    // Dedicated localStorage key, decoupled from the engine's `state`
    // envelope. The engine's state can be replaced wholesale by session match
    // restore (_restoreState does Object.assign over the whole state),
    // which races with our just-written activation when the shopper
    // navigates between collections faster than the 2s state-sync
    // debounce + backend round-trip. A separate key survives that race.
    var BS_LOCAL_KEY = '__bestSellerActivationsLocal';

    function _readLocalActivations() {
        try {
            var raw = localStorage.getItem(BS_LOCAL_KEY);
            if (!raw) return [];
            var arr = JSON.parse(raw);
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }

    function _writeLocalActivation(collectionId, sku, handle) {
        try {
            var cid = String(collectionId || '');
            var arr = _readLocalActivations();
            // Upsert: drop any prior entry for the same collectionId so the
            // placeholder we stamp PRE-flight gets replaced by the real
            // post-fetch entry (with sku). Without upsert we'd grow two
            // entries per activation -- harmless for the gate but messy.
            arr = arr.filter(function (e) { return e && e.collectionId !== cid; });
            arr.push({
                collectionId: cid,
                sku: String(sku || ''),
                handle: String(handle || ''),
                at: Date.now()
            });
            localStorage.setItem(BS_LOCAL_KEY, JSON.stringify(arr));
        } catch (e) {}
    }

    function _hasAnyBestSellerActivation() {
        // True when ANY best-seller has already been activated for this
        // shopper -- used by first-collection-only mode to skip subsequent
        // fetches across every collection the shopper visits.
        //
        // PRIMARY signal: our dedicated localStorage key (BS_LOCAL_KEY).
        // Survives any engine-state replacement (session match restore merges
        // the backend envelope OVER the local state, which previously
        // wiped our just-recorded activation when the shopper navigated
        // between collections before the 2s sync debounce fired).
        //
        // SECONDARY signals: engine state fields (bestSellerCollections /
        // bestSellerHandles). Group state is restored on identify via
        // session match, so a family member's prior activation counts even if
        // this device's localStorage doesn't have it yet.
        try {
            // Only a REAL activation (an entry that carries a sku) raises the global
            // first-collection gate. fetchCollectionBestSeller stamps an EMPTY-sku
            // placeholder BEFORE the network call; counting that here let a collection
            // with NO best-seller (or a failed fetch) permanently lock the gate, so a
            // LATER collection that SHOULD trigger was skipped. Empty placeholders are
            // ignored — the gate locks only once a collection truly activates one.
            var _acts = _readLocalActivations();
            for (var _i = 0; _i < _acts.length; _i++) {
                if (_acts[_i] && _acts[_i].sku) return true;
            }
        } catch (e) {}
        try {
            var eng = window.SE_Engine;
            if (!eng || !eng.state) return false;
            var map = eng.state.bestSellerCollections || {};
            for (var k in map) {
                if (Object.prototype.hasOwnProperty.call(map, k) && map[k]) return true;
            }
            var handles = eng.state.bestSellerHandles;
            if (Array.isArray(handles) && handles.length > 0) return true;
            return false;
        } catch (e) { return false; }
    }

    // One-time cleanup: strip EMPTY-sku placeholders left in BS_LOCAL_KEY by the
    // pre-flight write when a non-triggering / failed first collection used to leave
    // an empty entry that wrongly locked the first-collection gate. The gate above
    // now ignores empty entries, but purge them so a browser already polluted by the
    // old behaviour self-heals to a clean slate. Idempotent — safe to run every load.
    (function _purgeEmptyBsPlaceholders() {
        try {
            var arr = _readLocalActivations();
            var cleaned = arr.filter(function (e) { return e && e.sku; });
            if (cleaned.length !== arr.length) {
                localStorage.setItem(BS_LOCAL_KEY, JSON.stringify(cleaned));
            }
        } catch (e) {}
    })();

    // ── Group-state persistence ───────────────────────────────────────
    // Best-seller activations belong in the engine's group state envelope
    // (visitor_group.session_state.state_json), keyed by collection_id.
    // This way: (a) session matched shoppers re-joining the group see the same
    // best-seller badges without re-fetching analytics; (b) cross-device
    // recovery preserves the "this collection has had its best-seller
    // activated already" decision; (c) we save backend cost by skipping
    // the network call when state already has the answer.
    //
    // Storage shape on engine.state:
    //   bestSellerCollections: { "<collection_id>": { sku, activatedAt } }
    function _bestSellerStateForCollection(collectionId) {
        try {
            var eng = window.SE_Engine;
            if (!eng || !eng.state) return null;
            var map = eng.state.bestSellerCollections || {};
            return map[String(collectionId)] || null;
        } catch (e) { return null; }
    }

    function _recordBestSellerInState(collectionId, sku) {
        try {
            var eng = window.SE_Engine;
            if (!eng) return;
            if (!eng.state) eng.state = {};
            if (!eng.state.bestSellerCollections) eng.state.bestSellerCollections = {};
            eng.state.bestSellerCollections[String(collectionId)] = {
                sku: String(sku || ''),
                activatedAt: Date.now()
            };
            // Mirror to localStorage immediately so a hard reload in the
            // same tab picks it up before _bootVisitorIdentity completes.
            try {
                var key = eng.STORAGE_KEY;
                if (key && eng.state) {
                    localStorage.setItem(key, JSON.stringify(eng.state));
                }
            } catch (e) {}
            // Debounced POST to backend (collapses bursts into one call).
            if (typeof eng._scheduleStateSync === 'function') {
                eng._scheduleStateSync();
            }
        } catch (e) { /* swallow */ }
    }

    async function fetchCollectionBestSeller(collectionId) {
        // Group-state shortcut: if the engine already recorded a best-seller
        // for this collection (either earlier in this session OR restored
        // from backend via session match in _bootVisitorIdentity), skip the
        // analytics call and re-stamp the badge from state. _addBadge
        // early-returns when the card already carries a low-stock badge
        // (page-wide _badgedHandles set + DOM check), so even if a later
        // signal arrives we won't double-stamp.
        var restored = _bestSellerStateForCollection(collectionId);
        if (restored && restored.sku) {
            markItemLowStock(restored.sku);
            return;
        }
        // Belt-and-suspenders: enforce first-collection-only here too.
        // run() already gates this, but window.fetchCollectionBestSeller
        // is also exported for manual DevTools testing AND can be reached
        // via reapplyBestSellerForCurrentCollection -- if either path
        // skips the run() gate we still don't want to mint a new
        // activation when the group already has one.
        if (_activationModeFromPanel() === 'first-collection-only'
            && _hasAnyBestSellerActivation()) {
            return;
        }
        // PRE-FLIGHT GATE LOCK: stamp the activation BEFORE the network
        // call. The Render backend has a cold-start of 1-3s and shoppers
        // navigate between collections faster than that -- if we waited
        // for the response, the fetch would abort on every navigation
        // and we'd never persist a gate signal, causing every collection
        // page to re-fire fetchCollectionBestSeller. The placeholder
        // (empty sku) locks the gate; if the fetch completes we upsert
        // with the real sku via _writeLocalActivation's filter-and-push.
        _writeLocalActivation(collectionId, '', null);
        var rankBy = _rankByFromPanel();
        var geo = _geoipFlagsFromPanel();
        var url = BEST_SELLER_BASE_URL
            + '/get-collection-best-seller-per-country'
            + '?collection_id=' + encodeURIComponent(collectionId)
            + '&limit=1'
            + '&rank_by=' + encodeURIComponent(rankBy)
            + '&region_enabled=' + geo.enabled
            + '&region_persist=' + geo.persist;
        try {
            // Retry-with-backoff for Render cold-starts. Three attempts
            // (immediate, +1.5s, +4s) covers the typical 30-60s spin-up
            // window because the warm-up ping above runs in parallel.
            // Transient 502/503 + network errors retry; 4xx is treated as
            // a real failure (no point retrying a bad request).
            var data = null;
            var attempts = 3;
            var backoffMs = [0, 1500, 4000];
            for (var attempt = 0; attempt < attempts; attempt++) {
                if (backoffMs[attempt] > 0) {
                    await new Promise(function (r) { setTimeout(r, backoffMs[attempt]); });
                }
                var res = null;
                try {
                    res = await fetch(url);
                } catch (netErr) {
                    // Network error / CORS-from-cold-start. Retry.
                    try { console.log('[best-seller] fetch network error, will retry', { attempt: attempt + 1, err: String(netErr) }); } catch (e) {}
                    continue;
                }
                if (res.ok) {
                    data = await res.json();
                    break;
                }
                if (res.status >= 400 && res.status < 500) {
                    // 4xx -> permanent error, no point retrying.
                    try { console.log('[best-seller] fetch 4xx, abandoning', { status: res.status }); } catch (e) {}
                    return;
                }
                // 5xx / 502 / 503 -> Render likely still spinning up. Retry.
                try { console.log('[best-seller] fetch 5xx, will retry', { attempt: attempt + 1, status: res.status }); } catch (e) {}
            }
            if (!data) return;
            if (!Array.isArray(data) || data.length === 0) return;
            var row = data[0] || {};
            var sku = row.variant_sku;
            if (!sku) return;
            // Upsert: replace the empty placeholder we wrote pre-flight
            // with the real activation (sku attached). _writeLocalActivation
            // filters out prior same-collectionId entries before pushing.
            _writeLocalActivation(collectionId, sku, null);
            _recordBestSellerInState(collectionId, sku);
            // Diagnostic console log -- prefixed with [best-seller] so it's
            // greppable in the browser console. Survives the engine's
            // consoleLogsEnabled silencer (which only mutes a fixed list
            // of AGB-internal prefixes; [best-seller] isn't on that list).
            // Fires ONCE per shopper session under first-collection-only
            // mode -- if you see this appear twice in a session that's
            // your signal that the gate is broken.
            try {
                console.log('[best-seller] activated', {
                    collection_id: collectionId,
                    collection_handle: (typeof window !== 'undefined' && window.__currentCollectionHandle) || null,
                    sku: sku,
                    mode: _activationModeFromPanel(),
                    at: new Date().toISOString()
                });
            } catch (e) {}
            markItemLowStock(sku);
            _fireFreshActivationToast(sku);
        } catch (e) { /* swallow */ }
    }

    // Admin toast emission for a FRESH activation (not replay). Calls
    // the engine's existing _emitInfoToast which already honors the
    // panel's per-event filter (events.bestSellerActivated). The reason
    // this is a standalone function (vs inlined in _addBadge) is that
    // _addBadge runs on every replay -- we only want the toast for the
    // first-time activation in this collection.
    function _fireFreshActivationToast(sku) {
        try {
            var eng = window.SE_Engine;
            if (!eng || typeof eng._emitInfoToast !== 'function') return;
            var collection = window.__currentCollectionHandle || '';
            var msg = 'Best-seller activated for collection "'
                + collection + '" (sku ' + String(sku || '?').slice(0, 24) + ')';
            eng._emitInfoToast('bestSellerActivated', 'BEST SELLER', msg);
        } catch (e) { /* swallow */ }
    }

    // Re-apply best-seller badge for the CURRENT collection page using
    // group state. Called by the engine's _restoreState after a successful
    // session match -- state may arrive AFTER best-seller-toast.js already ran
    // its initial fetch (or skipped because sessionStorage was empty and
    // the network was slow). Idempotent via the badge dedup chain.
    function reapplyBestSellerForCurrentCollection() {
        try {
            // Re-apply ALL persisted handles first (any page, not just the
            // current collection). State arrived from the backend via
            // session match -- it may carry handles activated by a different
            // device / family member that we didn't know about during the
            // initial run().
            _applyPersistedBestSellerBadges();
            _persistedBestSellerHandles().forEach(_markBestSellerArrivalForBypass);
            // Then the current-collection fetch shortcut.
            var id = window.__currentCollectionId;
            if (!id) return;
            var restored = _bestSellerStateForCollection(id);
            if (restored && restored.sku) {
                markItemLowStock(restored.sku);
            }
        } catch (e) { /* swallow */ }
    }

    /**
     * Find the product card on the collection page that matches the given
     * SKU (preferred) or product name (fallback), and add a "LOW ON STOCK"
     * badge to it. Collection cards typically render the default variant,
     * which may not expose every SKU in the DOM — so name-match is the
     * realistic path for most cards.
     */
    // ─────────────────────────────────────────────────────────────────
    // CANONICAL BUNDLE CASCADE — body_html based.
    //
    // Bundle composition lives in the product description (admin sets it
    // via the Shopify-side Bundles app as a `<ul><li>` list of component
    // product names). The Shopify Ajax API `/products/<handle>.json`
    // exposes that description verbatim in `body_html`. We parse it,
    // slugify each component name to its Shopify handle, and cascade
    // bidirectionally:
    //
    //   FORWARD  : activated handle X      -> badge any bundle on the
    //                                         page whose FIRST <li>
    //                                         resolves to X
    //   REVERSE  : activated bundle Y      -> badge the card whose
    //                                         handle equals Y's FIRST
    //                                         <li> (slugified)
    //
    // Per user spec: matching is anchored on the FIRST component of the
    // <li> list. Non-first components don't trigger cascade (avoids
    // false-positive "Mag-Release Dump Pouch" → unrelated dump-pouch
    // bundles).
    //
    // Cached aggressively: per-handle JSON in sessionStorage + in-memory
    // map. A 24-card collection page does at most one round of fetches
    // total (for bundle-looking cards) on first visit; subsequent visits
    // hit the cache.
    // ─────────────────────────────────────────────────────────────────

    function _slugifyShopifyHandle(name) {
        if (!name) return '';
        return String(name)
            .toLowerCase()
            .replace(/[™®©]/g, '')
            .replace(/&[a-z]+;/gi, ' ')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    var _productJsonMem = {};
    var _productJsonInflight = {};
    // _v2: slim shape now includes variants[0] for default-color resolution.
    // Old cached entries (without variants) are ignored by the bumped prefix.
    var PRODUCT_JSON_CACHE_PREFIX = '__agbProductJson_v2:';

    async function _fetchProductJson(handle) {
        if (!handle) return null;
        if (Object.prototype.hasOwnProperty.call(_productJsonMem, handle)) {
            return _productJsonMem[handle];
        }
        try {
            var raw = sessionStorage.getItem(PRODUCT_JSON_CACHE_PREFIX + handle);
            if (raw) {
                var parsed = JSON.parse(raw);
                _productJsonMem[handle] = parsed;
                return parsed;
            }
        } catch (e) {}
        if (_productJsonInflight[handle]) return _productJsonInflight[handle];
        _productJsonInflight[handle] = (async function () {
            try {
                var res = await fetch('/products/' + encodeURIComponent(handle) + '.json');
                if (!res.ok) {
                    // Cache the null so we don't re-probe a 404 every time
                    _productJsonMem[handle] = null;
                    try { sessionStorage.setItem(PRODUCT_JSON_CACHE_PREFIX + handle, 'null'); } catch (e) {}
                    return null;
                }
                var data = await res.json();
                var product = (data && data.product) || null;
                _productJsonMem[handle] = product;
                try {
                    // Store only the fields we actually care about so the
                    // sessionStorage quota holds (Shopify product JSON can
                    // run several KB per product, but we only need
                    // body_html + title for parsing, plus the first
                    // variant's option values for default-color resolution
                    // in the cascade color filter).
                    var slim = product ? {
                        handle: product.handle,
                        title: product.title,
                        body_html: product.body_html,
                        options: product.options,
                        variants: (product.variants && product.variants.length)
                            ? [{
                                id: product.variants[0].id,
                                option1: product.variants[0].option1,
                                option2: product.variants[0].option2,
                                option3: product.variants[0].option3
                            }]
                            : []
                    } : null;
                    sessionStorage.setItem(PRODUCT_JSON_CACHE_PREFIX + handle, JSON.stringify(slim));
                } catch (e) {}
                return product;
            } catch (e) {
                return null;
            } finally {
                delete _productJsonInflight[handle];
            }
        })();
        return _productJsonInflight[handle];
    }

    // Parse a product's body_html for a bundle component list. Returns
    // { names, handles, firstName, firstHandle } when the body has a
    // <ul><li>...</li>...</ul> block with 2+ items; null otherwise.
    function _extractBundleComponentsFromHtml(html) {
        if (!html || typeof html !== 'string') return null;
        // Fast string check before invoking DOMParser
        if (html.indexOf('<li') === -1 || html.indexOf('<ul') === -1) return null;
        var doc;
        try {
            doc = new DOMParser().parseFromString(html, 'text/html');
        } catch (e) { return null; }
        if (!doc) return null;
        var lists = doc.querySelectorAll('ul');
        for (var i = 0; i < lists.length; i++) {
            var items = lists[i].querySelectorAll('li');
            if (items.length < 2) continue;          // single-item lists aren't bundles
            var names = [];
            for (var j = 0; j < items.length; j++) {
                var t = (items[j].textContent || '').replace(/\s+/g, ' ').trim();
                if (t && names.indexOf(t) === -1) names.push(t);
            }
            if (names.length < 2) continue;
            var handles = names.map(_slugifyShopifyHandle).filter(Boolean);
            if (handles.length < 2) continue;
            return {
                names: names,
                handles: handles,
                firstName: names[0],
                firstHandle: handles[0]
            };
        }
        return null;
    }

    // Resolve a handle to its bundle composition (if it is a bundle).
    // Returns the same shape as _extractBundleComponentsFromHtml or null.
    async function _bundleCompositionFor(handle) {
        if (!handle) return null;
        var product = await _fetchProductJson(handle);
        if (!product) return null;
        return _extractBundleComponentsFromHtml(product.body_html);
    }

    // FORWARD CASCADE: walk EVERY product-card on the page (no naming
    // heuristic), fetch its JSON, parse body_html, badge if its FIRST
    // <li> resolves to the activated handle.
    //
    // We used to pre-filter cards via a keyword heuristic ('bundle',
    // 'loadout', 'kit'...) to avoid fetching JSON for every card on
    // dense collection pages. That filter SILENTLY missed bundles whose
    // handle/title don't follow conventional naming -- e.g.
    // `k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates`
    // doesn't contain any of the keywords but IS a bundle whose first
    // <li> is "K-Zero™ SF Plate Carrier". The product description is
    // the only reliable signal; everything else is convention.
    //
    // Performance is bounded: each card costs at most one
    // /products/<handle>.json fetch (~3KB, Shopify CDN, HTTP/2
    // multiplexed). A 24-card collection page parallelizes the fetches
    // and completes in 200-500ms on cold cache. sessionStorage + memory
    // cache mean repeat visits do zero network work.
    async function _cascadeForwardFromComponent(componentHandle) {
        if (!componentHandle) return [];

        // Dual-mode color filter resolution (lifecycle-first, default-
        // variant fallback). Resolved ONCE here and reused across the
        // Catalog fast path AND the body_html fallback so both pipelines
        // honor the same rule:
        //
        //   * No lifecycle (best-seller stamp / fresh-product activation
        //     with no color context) → product's default-variant color
        //     is the filter. For magnetix-battle-belt that's Multicam,
        //     so only magnetix-bundle-multicam cascades.
        //   * One or more lifecycles with activeColor (shopper picked
        //     specific variants on the PDP) → all of those colors are
        //     the filter, cumulatively. Picking Multicam then Ranger
        //     Green badges BOTH loadouts.
        //   * Neither resolves a color → filter disabled (rare; product
        //     has no color option or no variants).
        var colorCtx = await _effectiveColorsForCascade(componentHandle);
        var colorSlugs = colorCtx.colors;
        try {
            if (colorSlugs.length > 0) {
                console.log('[best-seller] forward cascade COLOR FILTER (' + colorCtx.source + ')', {
                    component: componentHandle,
                    colors: colorSlugs
                });
            } else {
                console.log('[best-seller] forward cascade NO COLOR FILTER', { component: componentHandle });
            }
        } catch (e) {}

        // FAST PATH: window.Catalog (populated server-side from Liquid).
        // For Shopify-native bundles, this is the canonical source -- no
        // network call, no parsing, indexed lookup. If catalog.js loaded
        // and the bundles emitted data, we use this and skip everything
        // below.
        if (typeof window !== 'undefined' && window.Catalog && typeof window.Catalog.bundlesContainingAsFirst === 'function') {
            var primaries = window.Catalog.bundlesContainingAsFirst(componentHandle);
            if (primaries.length > 0) {
                var badgedFast = [];
                primaries.forEach(function (b) {
                    if (_badgedHandles.has(b.bundleHandle)) return;
                    if (colorSlugs.length > 0) {
                        var prod = window.Catalog.get(b.bundleHandle);
                        var title = (prod && prod.title) || '';
                        if (!_bundleMatchesAnyColor(b.bundleHandle, title, colorSlugs)) {
                            try { console.log('[best-seller] color filter SKIP (catalog)', { bundle: b.bundleHandle, expected: colorSlugs, source: colorCtx.source }); } catch (e) {}
                            return;
                        }
                    }
                    var card = _findCardByHandle(b.bundleHandle);
                    if (!card) return;
                    _addBadge(card);
                    badgedFast.push({ bundleHandle: b.bundleHandle, quantity: b.quantity, via: 'catalog', colors: colorSlugs.slice(), colorSource: colorCtx.source });
                });
                try {
                    console.log('[best-seller] forward cascade via window.Catalog', {
                        component: componentHandle,
                        bundlesAsFirst: primaries.map(function (b) { return b.bundleHandle; }),
                        badged: badgedFast
                    });
                } catch (e) {}
                if (badgedFast.length > 0) return badgedFast;
                // If Catalog found primaries but color filter rejected all,
                // STILL skip the body_html fallback -- Catalog is the canonical
                // source and a color-filter rejection is intentional.
                return [];
            }
            // Catalog has data but no bundles list this component as first.
            // It's correct to say "no cascade" here ONLY if catalog covers
            // every visible bundle. If catalog is partial (e.g. some cards
            // weren't rendered through product-card.liquid), fall through
            // to the body_html scan below.
        }

        // FALLBACK PATH: body_html scan + title heuristics. For products
        // not emitted via the catalog snippet (recommendation widgets,
        // pre-Liquid-snippet bundles, etc.).
        var cards = document.querySelectorAll('product-card[handle]');
        var candidates = [];
        for (var i = 0; i < cards.length; i++) {
            var c = cards[i];
            if (c.closest && c.closest(STEM_CARD_EXCLUDE_ANCESTORS)) continue;
            var h = c.getAttribute('handle');
            if (!h || h === componentHandle) continue;
            if (_badgedHandles.has(h)) continue;
            candidates.push({ card: c, handle: h });
        }
        if (!candidates.length) return [];
        var badged = [];
        var componentTitleNormalized = '';
        try {
            var componentProduct = await _fetchProductJson(componentHandle);
            if (componentProduct && componentProduct.title) {
                componentTitleNormalized = _normalizeTitle(componentProduct.title);
            }
        } catch (e) {}

        await Promise.all(candidates.map(async function (cand) {
            var bundle = await _bundleCompositionFor(cand.handle);
            // PRIMARY: body_html first-<li> exact-handle match.
            if (bundle && bundle.firstHandle === componentHandle) {
                if (colorSlugs.length > 0) {
                    var candProd = await _fetchProductJson(cand.handle);
                    var candTitle = (candProd && candProd.title) || '';
                    if (!_bundleMatchesAnyColor(cand.handle, candTitle, colorSlugs)) {
                        try { console.log('[best-seller] color filter SKIP (body_html)', { bundle: cand.handle, expected: colorSlugs, source: colorCtx.source }); } catch (e) {}
                        return;
                    }
                }
                if (_badgedHandles.has(cand.handle)) return;
                _addBadge(cand.card);
                badged.push({ bundleHandle: cand.handle, firstComponent: bundle.firstHandle, via: 'body_html', colors: colorSlugs.slice(), colorSource: colorCtx.source });
                return;
            }
            // FALLBACK: title-based name match. Catches bundles whose
            // description doesn't follow the <ul><li> convention OR
            // whose first <li> text doesn't slugify to a known handle.
            //
            // Match rule (deliberately strict to avoid false positives):
            //   - candidate card's title starts with `<componentTitle>`
            //     after normalization (lowercase + strip ™®© + collapse
            //     whitespace)
            //   - AND candidate card's title contains a bundle keyword
            //     somewhere after the component title.
            if (!componentTitleNormalized) return;
            var candProduct = await _fetchProductJson(cand.handle);
            if (!candProduct || !candProduct.title) return;
            var candTitleNorm = _normalizeTitle(candProduct.title);
            if (candTitleNorm === componentTitleNormalized) return;  // same product, not a bundle
            if (candTitleNorm.indexOf(componentTitleNormalized) !== 0) return;
            var rest = candTitleNorm.slice(componentTitleNormalized.length);
            if (!/\b(loadout|bundle|kit|package|combo|system|pack|set)\b/.test(rest)) return;
            if (colorSlugs.length > 0 && !_bundleMatchesAnyColor(cand.handle, candProduct.title, colorSlugs)) {
                try { console.log('[best-seller] color filter SKIP (title fallback)', { bundle: cand.handle, expected: colorSlugs, source: colorCtx.source }); } catch (e) {}
                return;
            }
            if (_badgedHandles.has(cand.handle)) return;
            _addBadge(cand.card);
            badged.push({ bundleHandle: cand.handle, matchedTitle: candProduct.title, via: 'title', colors: colorSlugs.slice(), colorSource: colorCtx.source });
        }));
        return badged;
    }

    // Lowercase, strip trademark/registered/copyright glyphs, collapse
    // whitespace. Used by the title-based forward fallback so name
    // matches are insensitive to ™ ® © and stray spaces.
    function _normalizeTitle(s) {
        return String(s || '')
            .toLowerCase()
            .replace(/[™®©]/g, '')
            .replace(/&[a-z]+;/gi, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    // Color slug: "Multicam" -> "multicam"; "Ranger Green" -> "ranger-green";
    // "Multicam Black" -> "multicam-black". Strips trademark symbols and
    // collapses non-alphanumeric runs to single hyphens. Used by the
    // color-aware bundle filter to keep "Magnetix Battle Belt activated
    // with Multicam" from cascading to the Ranger Green / Black loadouts.
    function _slugifyColor(name) {
        if (!name) return null;
        return String(name)
            .toLowerCase()
            .replace(/[™®©]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            || null;
    }

    // Collect color slugs from ALL active engine lifecycles keyed under
    // this handle (cumulative). Engine lifecycle keys are `<handle>` or
    // `<handle>_<variantId>`. Used by the cascade so picking Multicam
    // AND Ranger Green on the same product badges BOTH bundles, not
    // just the most-recent one. Returns [] when no lifecycle has an
    // activeColor set (which is when the default-variant fallback
    // kicks in — see _defaultColorSlugForProduct).
    function _activeColorSlugsForHandle(handle) {
        if (!handle) return [];
        try {
            var eng = window.SE_Engine;
            if (!eng || !eng.state || !eng.state.lifecycles) return [];
            var lcs = eng.state.lifecycles;
            var out = [];
            for (var k in lcs) {
                if (!Object.prototype.hasOwnProperty.call(lcs, k)) continue;
                if (k !== handle && k.indexOf(handle + '_') !== 0) continue;
                var lc = lcs[k];
                if (!lc || !lc.activeColor) continue;
                var c = _slugifyColor(lc.activeColor);
                if (c && out.indexOf(c) === -1) out.push(c);
            }
            return out;
        } catch (e) { return []; }
    }

    // Resolve the color slug of the product's DEFAULT variant. Reads
    // /products/<handle>.json (cached) and picks the option whose name
    // matches /color|colour|camo|camouflage|pattern/i, falling back to
    // option1 (Shopify's most common color-option position). The value
    // returned is from variants[0] — Shopify's first variant, which is
    // what the PDP shows as the pre-selected swatch when the shopper
    // lands on the page with no specific variant context.
    //
    // Used by the cascade as the FALLBACK color filter when no
    // lifecycle exists for this handle (e.g. the best-seller pipeline
    // activated the product without a specific color). For
    // magnetix-battle-belt whose first variant is "Multicam / Medium",
    // returns "multicam" — so the cascade badges magnetix-bundle-multicam
    // only, never the Ranger Green / Black loadouts.
    async function _defaultColorSlugForProduct(handle) {
        if (!handle) return null;
        var p = await _fetchProductJson(handle);
        if (!p) return null;
        var opts = p.options || [];
        var vars = p.variants || [];
        if (!opts.length || !vars.length) return null;
        var v0 = vars[0];
        if (!v0) return null;
        var colorRe = /\b(color|colour|camo|camouflage|pattern)\b/i;
        var colorIdx = -1;
        for (var i = 0; i < opts.length; i++) {
            if (colorRe.test(opts[i].name || '')) { colorIdx = i; break; }
        }
        // Fallback: most Shopify products with color+size encode color
        // as option1, so trust that convention when no name matches.
        if (colorIdx === -1) colorIdx = 0;
        var optKey = 'option' + (colorIdx + 1);
        return _slugifyColor(v0[optKey]);
    }

    // Effective color filter for the forward cascade. Two-mode resolution:
    //   1. lifecycle  — when one or more engine lifecycles for this handle
    //                   have an activeColor (shopper picked a specific
    //                   variant on the PDP), return ALL of them so the
    //                   cascade is cumulative across colors.
    //   2. default    — when no lifecycle exists (best-seller stamp /
    //                   fresh activation with no color context), use the
    //                   product's default-variant color. For
    //                   magnetix-battle-belt that's "multicam".
    //   3. none       — neither path yielded a color; the filter is
    //                   disabled and every bundle whose first <li>
    //                   resolves to this component cascades.
    async function _effectiveColorsForCascade(componentHandle) {
        var fromLifecycles = _activeColorSlugsForHandle(componentHandle);
        if (fromLifecycles.length > 0) {
            return { source: 'lifecycle', colors: fromLifecycles };
        }
        var defaultColor = await _defaultColorSlugForProduct(componentHandle);
        if (defaultColor) {
            return { source: 'default', colors: [defaultColor] };
        }
        return { source: 'none', colors: [] };
    }

    // True iff the bundle matches ANY of the given color slugs. Cumulative
    // semantics: if the shopper triggered Multicam AND Ranger Green
    // lifecycles on the same component, both colored bundles get
    // badged.
    function _bundleMatchesAnyColor(bundleHandle, bundleTitle, colorSlugs) {
        if (!colorSlugs || colorSlugs.length === 0) return true;
        for (var i = 0; i < colorSlugs.length; i++) {
            if (_bundleMatchesColor(bundleHandle, bundleTitle, colorSlugs[i])) return true;
        }
        return false;
    }

    // Known color slugs in this catalog. Used by _bundleMatchesColor's
    // "colorless bundle" detection so that bundles whose handle/title
    // carry NO color token at all (e.g. k-zero-sf-bundle, sub-zero-bundle,
    // reaper-rig-bundle — single-color or color-agnostic bundles) match
    // every color filter and get the cascade badge. Without this list
    // we'd have to call colors-match against the activated color, and a
    // single colorless bundle would never match a colored filter.
    //
    // Multi-word slugs first so the longest-match scan catches
    // "multicam-black" before "black", "ranger-green" before "green", etc.
    var KNOWN_COLOR_SLUGS_FOR_FILTER = [
        'multicam-black', 'ranger-green', 'coyote-tan', 'coyote-brown',
        'm81-woodland', 'wolf-grey', 'olive-drab', 'sar-orange',
        'forest-green', 'blood-red', 'navy', 'purple', 'cyber',
        'hi-vis-yellow', 'glow-in-the-dark', 'blackout',
        'multicam', 'woodland', 'black', 'tan', 'green', 'brown',
        'grey', 'gray', 'olive', 'red', 'blue', 'orange', 'yellow'
    ];

    // Does the bundle handle / title carry ANY recognized color token?
    // True for "magnetix-bundle-multicam" (has "multicam"), false for
    // "k-zero-sf-bundle" (no color token). Colorless bundles match every
    // color filter — see _bundleMatchesColor below.
    function _bundleHasAnyColorToken(bundleHandle, bundleTitle) {
        var h = (bundleHandle || '').toLowerCase();
        var t = _slugifyColor(bundleTitle) || '';
        for (var i = 0; i < KNOWN_COLOR_SLUGS_FOR_FILTER.length; i++) {
            var c = KNOWN_COLOR_SLUGS_FOR_FILTER[i];
            if (h.indexOf('-' + c) !== -1 || h.indexOf(c + '-') !== -1 || h === c) return true;
            if (t && (t.indexOf('-' + c) !== -1 || t.indexOf(c + '-') !== -1 || t === c)) return true;
        }
        return false;
    }

    // Check whether a candidate bundle "is the X color" given an activated
    // color slug. Tests both the bundle's HANDLE (e.g. magnetix-bundle-
    // multicam) and TITLE (e.g. "Magnetix™ Battle Belt Loadout Multicam")
    // for the color token. Three outcomes:
    //   - colorSlug is null   → return true (no filter active)
    //   - bundle handle/title carries the color token → return true
    //   - bundle handle/title carries NO color token at all → return true
    //     (colorless bundle like k-zero-sf-bundle: matches every color
    //     because it's not color-specific)
    //   - bundle handle/title carries a DIFFERENT color token → return false
    //     (this is the "magnetix-bundle-ranger-green when multicam was
    //     triggered" rejection)
    function _bundleMatchesColor(bundleHandle, bundleTitle, colorSlug) {
        if (!colorSlug) return true;  // no filter
        var h = (bundleHandle || '').toLowerCase();
        if (h.indexOf('-' + colorSlug) !== -1 || h.indexOf(colorSlug + '-') !== -1 || h === colorSlug) {
            return true;
        }
        var titleSlug = _slugifyColor(bundleTitle);
        if (titleSlug && (titleSlug.indexOf('-' + colorSlug) !== -1 || titleSlug.indexOf(colorSlug + '-') !== -1)) {
            return true;
        }
        // Colorless bundle (no color token in handle or title) — matches every color.
        if (!_bundleHasAnyColorToken(bundleHandle, bundleTitle)) {
            return true;
        }
        return false;
    }

    // REVERSE CASCADE: if the activated handle IS itself a bundle, badge
    // the card whose handle equals the bundle's FIRST <li> (slugified).
    // Title-based fallback covers bundles whose description doesn't follow
    // the <ul><li> convention -- name-match the bundle's title against
    // every visible card's title, look for one whose name is a prefix of
    // the bundle's title (i.e. "Magnetix Battle Belt" prefixes "Magnetix
    // Battle Belt Loadout Multicam"). ™/®/© stripped during normalization.
    async function _cascadeReverseFromBundle(bundleHandle) {
        if (!bundleHandle) return null;

        // FAST PATH: window.Catalog (server-side rendered native data).
        // If the bundle's first component is known via Catalog, badge it
        // directly. No fetch, no parsing, no slug guessing.
        if (typeof window !== 'undefined' && window.Catalog && typeof window.Catalog.firstComponentOf === 'function') {
            var first = window.Catalog.firstComponentOf(bundleHandle);
            if (first && first.handle) {
                if (_badgedHandles.has(first.handle)) {
                    try { console.log('[best-seller] reverse cascade via Catalog: first component already badged', { bundleHandle: bundleHandle, firstHandle: first.handle }); } catch (e) {}
                    return { firstHandle: first.handle, firstName: first.title, alreadyBadged: true, via: 'catalog' };
                }
                var cardC = _findCardByHandle(first.handle);
                if (cardC) {
                    _addBadge(cardC);
                    try { console.log('[best-seller] reverse cascade via Catalog: BADGED first component', { bundleHandle: bundleHandle, firstHandle: first.handle, firstName: first.title }); } catch (e) {}
                    return { firstHandle: first.handle, firstName: first.title, via: 'catalog' };
                }
                try { console.log('[best-seller] reverse cascade via Catalog: first component card NOT on page', { bundleHandle: bundleHandle, firstHandle: first.handle }); } catch (e) {}
                // Don't fall through to body_html: Catalog said "first
                // component is X", we just couldn't find X's card. body_html
                // would give the same answer.
                return { firstHandle: first.handle, firstName: first.title, cardOnPage: false, via: 'catalog' };
            }
            // Catalog has no entry for this handle as bundle. Maybe the
            // bundle's catalog data wasn't emitted (rendered outside
            // product-card.liquid). Fall through to body_html.
        }

        var bundle = await _bundleCompositionFor(bundleHandle);

        // FALLBACK: body_html first-<li> slugified to a handle, find that
        // card directly.
        if (bundle && bundle.firstHandle) {
            if (_badgedHandles.has(bundle.firstHandle)) {
                try { console.log('[best-seller] reverse cascade: first component already badged elsewhere', { bundleHandle: bundleHandle, firstHandle: bundle.firstHandle }); } catch (e) {}
                return { firstHandle: bundle.firstHandle, firstName: bundle.firstName, alreadyBadged: true };
            }
            var card = _findCardByHandle(bundle.firstHandle);
            if (card) {
                _addBadge(card);
                try { console.log('[best-seller] reverse cascade: BADGED first component via body_html', { bundleHandle: bundleHandle, firstHandle: bundle.firstHandle, firstName: bundle.firstName }); } catch (e) {}
                return { firstHandle: bundle.firstHandle, firstName: bundle.firstName, via: 'body_html' };
            }
            try { console.log('[best-seller] reverse cascade: first component card NOT on this page (body_html path)', { bundleHandle: bundleHandle, firstHandle: bundle.firstHandle, firstName: bundle.firstName }); } catch (e) {}
            // Fall through to title-based -- the firstHandle slug may
            // not match an actual product if the bundle description has
            // typos or differs from the canonical product title.
        }

        // FALLBACK: title-based. Walk every product-card[handle] on the
        // page; pick the card whose normalized title is the LONGEST
        // strict prefix of the bundle's normalized title AND is followed
        // by a bundle keyword. Strict prefix + keyword keeps false
        // positives out (a "Magnetix Battle Belt Pouch" card won't match
        // because "Pouch" isn't a bundle keyword).
        try {
            var bundleProduct = await _fetchProductJson(bundleHandle);
            if (!bundleProduct || !bundleProduct.title) {
                try { console.log('[best-seller] reverse cascade: bundle JSON unavailable for title fallback', { bundleHandle: bundleHandle }); } catch (e) {}
                return null;
            }
            var bundleTitleNorm = _normalizeTitle(bundleProduct.title);
            var cards = document.querySelectorAll('product-card[handle]');
            var best = null;
            for (var i = 0; i < cards.length; i++) {
                var c = cards[i];
                if (c.closest && c.closest(STEM_CARD_EXCLUDE_ANCESTORS)) continue;
                var h = c.getAttribute('handle');
                if (!h || h === bundleHandle) continue;
                if (_badgedHandles.has(h)) continue;
                var prod = await _fetchProductJson(h);
                if (!prod || !prod.title) continue;
                var candTitleNorm = _normalizeTitle(prod.title);
                if (candTitleNorm === bundleTitleNorm) continue;
                // candidate title must be a STRICT PREFIX of bundle title
                if (bundleTitleNorm.indexOf(candTitleNorm) !== 0) continue;
                var rest = bundleTitleNorm.slice(candTitleNorm.length);
                if (!/\b(loadout|bundle|kit|package|combo|system|pack|set)\b/.test(rest)) continue;
                // Pick the LONGEST matching prefix (most specific component).
                if (!best || candTitleNorm.length > best.titleLength) {
                    best = { card: c, handle: h, name: prod.title, titleLength: candTitleNorm.length };
                }
            }
            if (best) {
                _addBadge(best.card);
                try { console.log('[best-seller] reverse cascade: BADGED first component via title fallback', { bundleHandle: bundleHandle, firstHandle: best.handle, firstName: best.name }); } catch (e) {}
                return { firstHandle: best.handle, firstName: best.name, via: 'title' };
            }
            try { console.log('[best-seller] reverse cascade: no title-prefix match for bundle', { bundleHandle: bundleHandle, bundleTitle: bundleProduct.title }); } catch (e) {}
        } catch (e) { /* swallow */ }
        return null;
    }

    async function markItemLowStock(sku) {
        var primaryHandle = null;
        // 1. Direct [data-sku] hit (rare on collection cards — they typically
        //    expose only the default variant's SKU if any).
        var card = _findCardBySku(sku);
        if (card) {
            _addBadge(card);
            primaryHandle = card.getAttribute && card.getAttribute('handle');
        } else {
            // 2. Resolve SKU -> product handle via Shopify's search endpoint,
            //    then match the card by its /products/<handle> link.
            primaryHandle = await _resolveHandleForSku(sku);
            if (primaryHandle) {
                card = _findCardByHandle(primaryHandle);
                if (card) _addBadge(card);
            }
        }
        // 3. CANONICAL BIDIRECTIONAL CASCADE — body_html anchored on
        //    the FIRST <li>. The Shopify Bundles app stores composition
        //    in the product description as a `<ul><li>` list; Shopify's
        //    Ajax API exposes that description in `body_html`. We parse
        //    it and slugify component names → handles.
        //
        //    FORWARD : activated component handle X → badge any bundle
        //              whose first <li> resolves to X. (Non-first
        //              components are intentionally NOT cascaded — per
        //              spec, only the "1st product in the list" pairs
        //              with the bundle.)
        //    REVERSE : activated bundle handle Y → badge the card whose
        //              handle equals Y's FIRST <li> slugified.
        //
        //    Cached via `_fetchProductJson` (sessionStorage + in-memory).
        //    Each bundle product is fetched at most once per session.
        if (primaryHandle) {
            try {
                var forwardResults = await _cascadeForwardFromComponent(primaryHandle);
                var reverseResult  = await _cascadeReverseFromBundle(primaryHandle);
                console.log('[best-seller] bundle cascade (body_html, first-li anchored)', {
                    primary: primaryHandle,
                    forward_badged_bundles: forwardResults,
                    reverse_badged_first_component: reverseResult
                });
            } catch (e) {
                try { console.warn('[best-seller] bundle cascade failed', e); } catch (e2) {}
            }
        }
    }

    // Reverse-cascade resolver: given a handle that MIGHT be a bundle,
    // return the handle of its FIRST/primary component (option1 in
    // BUNDLE_DATA, or stem-stripped base handle for unknown bundles like
    // Magnetix loadouts). Returns null if the handle isn't a bundle.
    //
    //   sub-zero-ranger-green-bundle      -> sub-zero-plate-carrier (map)
    //   magnetix-battle-belt-loadout-multicam -> magnetix-battle-belt (stem)
    //   k-zero-plate-carrier              -> null (not a bundle)
    function _findFirstComponentOfBundle(bundleHandle) {
        if (!bundleHandle) return null;
        // Strategy A: explicit BUNDLE_DATA. First component is the value
        // of optionToHandle.option1. Covers k-zero / sub-zero / reaper /
        // anything explicitly registered in agb-bundles.js.
        try {
            var Bundles = (window.AGB && typeof window.AGB.require === 'function')
                ? window.AGB.require('bundles') : null;
            var data = Bundles && Bundles.BUNDLE_DATA;
            if (data && data[bundleHandle]) {
                var spec = data[bundleHandle];
                if (spec && spec.optionToHandle && typeof spec.optionToHandle.option1 === 'string') {
                    return spec.optionToHandle.option1;
                }
            }
        } catch (e) { /* swallow */ }
        // Strategy B: stem-strip heuristic. Walk progressively shorter
        // prefixes of the handle (longest first = most specific) and
        // return the first one that matches a real card on the current
        // page. This catches Magnetix loadouts where the handle convention
        // is `<component>-loadout-<color>` without going to the network
        // (we only badge what's visible anyway).
        try {
            var parts = String(bundleHandle).split('-');
            if (parts.length < 2) return null;
            for (var i = parts.length - 1; i >= 1; i--) {
                var candidate = parts.slice(0, i).join('-');
                if (candidate === bundleHandle) continue;
                if (_findCardByHandle(candidate)) return candidate;
            }
        } catch (e) { /* swallow */ }
        return null;
    }

    // Handle-stem cascade: scan every product-card[handle] on the page
    // and return any whose handle starts with `<componentHandle>-`. This
    // catches loadout/bundle variants that aren't in BUNDLE_DATA, e.g.:
    //   primary = "magnetix-battle-belt"
    //   hits    = ["magnetix-battle-belt-loadout-multicam",
    //              "magnetix-battle-belt-loadout-ranger-green", ...]
    // Excludes the component itself (exact-match handle) and any cards
    // inside drawers / dialogs / mini-cart / search results.
    var STEM_CARD_EXCLUDE_ANCESTORS = 'cart-drawer, predictive-search, header, footer, dialog, [role="dialog"], aside';
    function _findCardHandlesByStem(componentHandle) {
        var hits = [];
        if (!componentHandle) return hits;
        try {
            var prefix = componentHandle + '-';
            var cards = document.querySelectorAll('product-card[handle]');
            for (var i = 0; i < cards.length; i++) {
                var c = cards[i];
                if (c.closest && c.closest(STEM_CARD_EXCLUDE_ANCESTORS)) continue;
                var h = c.getAttribute('handle');
                if (!h) continue;
                if (h === componentHandle) continue;
                if (h.indexOf(prefix) !== 0) continue;
                hits.push(h);
            }
        } catch (e) { /* swallow */ }
        return hits;
    }

    // Walk BUNDLE_DATA (exposed by agb-bundles.js via AGB.require('bundles'))
    // and return every bundle handle that lists `componentHandle` as one of:
    //   - optionToHandle.optionN values   (the bundle's primary component
    //     for that option; e.g. sub-zero-plate-carrier is option1 for
    //     sub-zero-ranger-green-bundle)
    //   - defaults keys                   (component handles the bundle
    //     pre-fills option values for)
    //   - includedItems                   (additional fixed-include
    //     component handles)
    // Returns [] when AGB.bundles isn't loaded or the handle isn't
    // referenced anywhere. Quiet failure -- the worst case is the bundle
    // card simply doesn't get the badge, no crash.
    function _findBundlesContaining(componentHandle) {
        var out = [];
        // Strategy A2: engine's BUNDLE_COMPONENT_MAP. UNLIKE BUNDLE_DATA
        // (which lives in agb-bundles.js and is loaded ONLY on AGB Gear
        // Builder PDPs), the engine's map is on window.SE_Engine and
        // therefore available on EVERY page including collection grids.
        // This is what catches `k-zero-sf-bundle` when the activated
        // component is `k-zero-sf-plate-carrier` -- the bundle handle
        // doesn't match a stem prefix of the component, so the stem
        // cascade misses it, and BUNDLE_DATA isn't loaded on /collections,
        // so Strategy A misses it too. Engine map fills the gap.
        try {
            var engMap = (window.SE_Engine && window.SE_Engine.BUNDLE_COMPONENT_MAP) || null;
            if (engMap && componentHandle) {
                for (var ebh in engMap) {
                    if (!Object.prototype.hasOwnProperty.call(engMap, ebh)) continue;
                    var ecomps = engMap[ebh];
                    if (Array.isArray(ecomps) && ecomps.indexOf(componentHandle) !== -1) {
                        if (out.indexOf(ebh) === -1) out.push(ebh);
                    }
                }
            }
        } catch (e) { /* swallow */ }
        // Strategy A: BUNDLE_DATA lookup via agb-bundles.js. Only loaded
        // on the AGB Gear Builder PDPs, so this is a no-op on collection
        // pages -- but when it IS available it carries the richer spec
        // (defaults / includedItems) that the engine's component-array
        // map omits, so we union both.
        try {
            var Bundles = null;
            try {
                Bundles = (window.AGB && typeof window.AGB.require === 'function')
                    ? window.AGB.require('bundles') : null;
            } catch (e) { Bundles = null; }
            var data = Bundles && Bundles.BUNDLE_DATA;
            if (!data) return out;
            var target = String(componentHandle || '').toLowerCase();
            if (!target) return out;
            for (var bundleHandle in data) {
                if (!Object.prototype.hasOwnProperty.call(data, bundleHandle)) continue;
                var spec = data[bundleHandle];
                if (!spec) continue;
                var match = false;
                if (spec.optionToHandle && typeof spec.optionToHandle === 'object') {
                    for (var k in spec.optionToHandle) {
                        if (!Object.prototype.hasOwnProperty.call(spec.optionToHandle, k)) continue;
                        if (String(spec.optionToHandle[k] || '').toLowerCase() === target) {
                            match = true;
                            break;
                        }
                    }
                }
                if (!match && spec.defaults && typeof spec.defaults === 'object') {
                    for (var dh in spec.defaults) {
                        if (!Object.prototype.hasOwnProperty.call(spec.defaults, dh)) continue;
                        if (String(dh).toLowerCase() === target) {
                            match = true;
                            break;
                        }
                    }
                }
                if (!match && Array.isArray(spec.includedItems)) {
                    for (var i = 0; i < spec.includedItems.length; i++) {
                        if (String(spec.includedItems[i] || '').toLowerCase() === target) {
                            match = true;
                            break;
                        }
                    }
                }
                if (match) out.push(bundleHandle);
            }
        } catch (e) { /* swallow */ }
        return out;
    }

    // Resolve SKU -> product handle. Two strategies:
    //   1. /search/suggest.json — fast if the storefront indexes SKUs
    //      (often it doesn't, but cheap to try).
    //   2. /collections/<handle>/products.json — walks every variant of
    //      every product in the current collection; reliable but heavier.
    async function _resolveHandleForSku(sku) {
        if (!sku) return null;

        // 1. Predictive search
        try {
            var url = '/search/suggest.json?q=' + encodeURIComponent(sku)
                + '&resources%5Btype%5D=product&resources%5Blimit%5D=5';
            var res = await fetch(url);
            if (res.ok) {
                var data = await res.json();
                var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
                if (products.length && products[0].handle) return products[0].handle;
            }
        } catch (e) { /* swallow */ }

        // 2. Walk the current collection's products
        var collectionHandle = window.__currentCollectionHandle;
        if (!collectionHandle) return null;
        try {
            var collUrl = '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250';
            var cres = await fetch(collUrl);
            if (!cres.ok) return null;
            var cdata = await cres.json();
            var prods = cdata.products || [];
            for (var i = 0; i < prods.length; i++) {
                var variants = prods[i].variants || [];
                for (var j = 0; j < variants.length; j++) {
                    if (variants[j].sku === sku) return prods[i].handle;
                }
            }
        } catch (e) { /* swallow */ }
        return null;
    }

    function _findCardByHandle(handle) {
        if (!handle) return null;
        // PRIMARY: exact match on `product-card[handle="<handle>"]`. The
        // Prestige theme stamps the handle as an attribute on the custom
        // element, so this is the precise way to find the right card.
        // Previously this used `a[href*="/products/<handle>"]` which
        // CSS substring-matches -- e.g. searching for "magnetix-battle-
        // belt" would falsely match a link to "magnetix-battle-belt-pouch"
        // and `_closestCard` would walk up to the wrong card. The exact
        // attribute selector has no such ambiguity.
        try {
            // CSS attribute-equals is case-sensitive and supports special
            // chars when properly escaped. CSS.escape isn't available in
            // older browsers, so fall back to a manual escape of " and \.
            var esc = (window.CSS && typeof CSS.escape === 'function')
                ? CSS.escape(handle)
                : String(handle).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
            var direct = document.querySelector('product-card[handle="' + esc + '"]');
            if (direct) {
                if (direct.closest(CARD_EXCLUDE_ANCESTORS)) return null;
                return direct;
            }
        } catch (e) { /* fall through */ }
        // FALLBACK: walk every product link, parse the path segment after
        // /products/ exactly, ignoring the substring noise. Some themes
        // may use `.product-card` (class) instead of <product-card>
        // (custom element); the fallback covers those too.
        try {
            var anchors = document.querySelectorAll('a[href*="/products/"]');
            for (var i = 0; i < anchors.length; i++) {
                var href = anchors[i].getAttribute('href') || '';
                // Extract the handle segment: /products/<handle>(?:[/?#]|$)
                var m = href.match(/\/products\/([^/?#]+)/);
                if (!m) continue;
                if (m[1] !== handle) continue;
                var card = _closestCard(anchors[i]);
                if (card) return card;
            }
        } catch (e) {}
        return null;
    }

    function _findCardBySku(sku) {
        if (!sku || !window.CSS || typeof CSS.escape !== 'function') return null;
        var hit = document.querySelector('[data-sku="' + CSS.escape(sku) + '"]');
        return hit ? _closestCard(hit) : null;
    }

    // Tight card selector — only real Prestige product-cards on grids.
    // Excludes mini-cart line items, predictive-search rows, header
    // drawers and any other "card-shaped" UI in dialogs.
    var CARD_EXCLUDE_ANCESTORS = 'cart-drawer, predictive-search, header, footer, dialog, [role="dialog"], aside';
    function _closestCard(el) {
        var card = el.closest('product-card');
        if (!card) return null;
        if (card.closest(CARD_EXCLUDE_ANCESTORS)) return null;
        return card;
    }

    // Page-wide dedup shared with low-stock-targets.js — at most ONE badge
    // per product handle on this page load, no matter how many cards link
    // to the product or how many systems try to badge it.
    window._AGB_badgedHandles = window._AGB_badgedHandles || new Set();
    var _badgedHandles = window._AGB_badgedHandles;

    function _hasLowStockBadge(card) {
        if (card.querySelector('.badge--low-stock')) return true;
        var badges = card.querySelectorAll('.badge');
        for (var i = 0; i < badges.length; i++) {
            var txt = (badges[i].textContent || '').trim().toUpperCase();
            if (txt === 'LOW STOCK' || txt === 'LOW ON STOCK') return true;
        }
        return false;
    }
    // A sold-out product card carries Prestige's <sold-out-badge> (rendered by
    // product-badges.liquid, visible only when the product's first-available
    // variant is unavailable). Never stack LOW ON STOCK on a SOLD OUT card.
    function _isSoldOut(card) {
        try {
            return !!(card && card.querySelector('sold-out-badge:not([hidden]), .badge--sold-out:not([hidden])'));
        } catch (e) { return false; }
    }
    // Read badge placement from the panel-loaded config, falling back to
    // the historical defaults (top-left, 0.25rem from each edge, z-index 1
    // -- theme parity with .product-card__figure > .badge-list at theme.css:2150).
    // The shape matches BestSellerConfig.badgePosition in the panel.
    function _badgePositionFromConfig() {
        var fallback = {
            anchor: 'top-left',
            offsetVerticalRem: 0.25,
            offsetHorizontalRem: 0.25,
            zIndex: 1
        };
        try {
            // Prefer the new top-level lowStockBadgePosition (unified for
            // every low-stock badge: lifecycle / inventory / best-seller /
            // bundle cascade). Fall back to the legacy
            // bestSeller.badgePosition for envelopes saved before the
            // promotion to top level.
            var bp = window.SE_Engine
                && window.SE_Engine.config
                && (window.SE_Engine.config.lowStockBadgePosition
                    || (window.SE_Engine.config.bestSeller
                        && window.SE_Engine.config.bestSeller.badgePosition));
            if (!bp) return fallback;
            var validAnchors = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
            return {
                anchor: validAnchors.indexOf(bp.anchor) !== -1 ? bp.anchor : fallback.anchor,
                offsetVerticalRem:   Number.isFinite(bp.offsetVerticalRem)   ? bp.offsetVerticalRem   : fallback.offsetVerticalRem,
                offsetHorizontalRem: Number.isFinite(bp.offsetHorizontalRem) ? bp.offsetHorizontalRem : fallback.offsetHorizontalRem,
                zIndex:              Number.isFinite(bp.zIndex)              ? bp.zIndex              : fallback.zIndex
            };
        } catch (e) { return fallback; }
    }
    function _applyBadgePosition(span, pos) {
        span.style.position = 'absolute';
        // Reset every edge so changing anchor at runtime doesn't leave a
        // stale opposite-side value pinning the badge.
        span.style.top = span.style.bottom = span.style.left = span.style.right = '';
        if (pos.anchor === 'top-left') {
            span.style.top  = pos.offsetVerticalRem   + 'rem';
            span.style.left = pos.offsetHorizontalRem + 'rem';
        } else if (pos.anchor === 'top-right') {
            span.style.top   = pos.offsetVerticalRem   + 'rem';
            span.style.right = pos.offsetHorizontalRem + 'rem';
        } else if (pos.anchor === 'bottom-left') {
            span.style.bottom = pos.offsetVerticalRem   + 'rem';
            span.style.left   = pos.offsetHorizontalRem + 'rem';
        } else { // bottom-right
            span.style.bottom = pos.offsetVerticalRem   + 'rem';
            span.style.right  = pos.offsetHorizontalRem + 'rem';
        }
        span.style.zIndex = String(pos.zIndex);
    }
    // Flat list of product handles ever activated by best-seller for this
    // shopper's group. Lives on engine.state so it persists in localStorage
    // and round-trips through the backend group-state envelope on session match.
    // Drives cross-collection re-badging: any card whose handle is in this
    // set gets the LOW ON STOCK badge re-applied on the next page load,
    // even if best-seller hasn't fetched for the new collection. Replaces
    // the earlier synthetic-lifecycle approach -- per product decision,
    // best-seller is now BADGE-ONLY (no lifecycle at activation); the
    // lifecycle is created naturally when the shopper enters the product's
    // PDP, governed by the normal canStartLifecycle gates plus the
    // best-seller bypass (see __bestSellerArrivals below).
    function _persistedBestSellerHandles() {
        try {
            var eng = window.SE_Engine;
            var arr = eng && eng.state && eng.state.bestSellerHandles;
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }

    function _recordBestSellerHandleInState(handle) {
        try {
            if (!handle) return;
            var eng = window.SE_Engine;
            if (!eng) return;
            if (!eng.state) eng.state = {};
            if (!Array.isArray(eng.state.bestSellerHandles)) eng.state.bestSellerHandles = [];
            if (eng.state.bestSellerHandles.indexOf(handle) === -1) {
                eng.state.bestSellerHandles.push(handle);
                // Mirror immediately to localStorage so a hard reload
                // before the debounced backend sync still sees the value.
                try {
                    var key = eng.STORAGE_KEY;
                    if (key && eng.state) {
                        localStorage.setItem(key, JSON.stringify(eng.state));
                    }
                } catch (e) {}
                if (typeof eng._scheduleStateSync === 'function') {
                    eng._scheduleStateSync();
                }
            }
        } catch (e) {}
    }

    // sessionStorage write that the engine's _bestSellerExtraLifecyclesAllowed
    // (agb-variant-extension.js:4571-4590) already reads. Marks the handle
    // as "shopper arrived here via a best-seller badge", which the engine's
    // canStartLifecycle path uses to grant the configured
    // extraLifecyclesPerProduct slot when normal caps are full. Without
    // this writer the bypass was a dead reader (see audit report). Scoped
    // to sessionStorage so it resets when the tab is closed -- the bypass
    // is a per-shopping-session affordance, not a permanent override.
    function _markBestSellerArrivalForBypass(handle) {
        try {
            if (!handle) return;
            if (typeof sessionStorage === 'undefined') return;
            var raw = sessionStorage.getItem('__bestSellerArrivals');
            var arr = [];
            if (raw) {
                try { arr = JSON.parse(raw); } catch (e) { arr = []; }
                if (!Array.isArray(arr)) arr = [];
            }
            if (arr.indexOf(handle) === -1) {
                arr.push(handle);
                sessionStorage.setItem('__bestSellerArrivals', JSON.stringify(arr));
            }
        } catch (e) {}
    }

    // Engine-answered: would the PDP show urgency for this handle? Engine
    // absent / older build -> true (fail open, previous behaviour).
    function _pdpWouldShowUrgency(handle) {
        try {
            var eng = window.SE_Engine;
            if (!eng || typeof eng.willShowUrgencyOnPDP !== 'function') return true;
            return !!eng.willShowUrgencyOnPDP(handle);
        } catch (e) { return true; }
    }

    function _applyPersistedBestSellerBadges() {
        // Walk the handles list and badge any card on the current page
        // whose handle matches. Runs on every page load (collection,
        // search, homepage) so a best-seller activation made on Collection
        // A keeps showing on Collection B, search results, etc.
        // Idempotent: _addBadge dedups via _badgedHandles + _hasLowStockBadge.
        //
        // ALSO fires the body_html bidirectional cascade for each persisted
        // handle so bundles (and the bundle's first component) get the
        // badge too, not just the originally-activated card. Fire-and-
        // forget; the dedup chain inside _addBadge prevents double stamps
        // if the user navigates between collections.
        var handles = _persistedBestSellerHandles();
        if (!handles.length) return;
        for (var i = 0; i < handles.length; i++) {
            // REPLAY ONLY paints a promise the PDP can keep. bestSellerHandles
            // is append-only and backend-synced - without this the badge
            // outlived its workflow forever while the product page showed
            // nothing (Dorian 2026-08-12). Fresh activations bypass this
            // function entirely, so a newly-picked best-seller still badges.
            if (!_pdpWouldShowUrgency(handles[i])) continue;
            var card = _findCardByHandle(handles[i]);
            if (card) _addBadge(card);
            // Async cascade -- runs in parallel, no need to await each.
            (function (h) {
                try {
                    Promise.resolve().then(function () { return _cascadeForwardFromComponent(h); }).catch(function () {});
                    Promise.resolve().then(function () { return _cascadeReverseFromBundle(h); }).catch(function () {});
                } catch (e) {}
            })(handles[i]);   // cascades ride the same gate: unreachable handles never get here
        }
    }

    function _addBadge(card) {
        if (_hasLowStockBadge(card)) return;
        if (_isSoldOut(card)) return; // never LOW ON STOCK on a sold-out product
        var handle = card.getAttribute('handle');
        if (handle && _badgedHandles.has(handle)) return;
        var span = document.createElement('span');
        span.className = 'badge badge--custom badge--low-stock';
        span.textContent = ((window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.stockBadge && !/^translation missing/i.test(window.themeVariables.strings.stockBadge)) ? String(window.themeVariables.strings.stockBadge).toUpperCase() : 'LOW ON STOCK'); // agilite_stock.badge, 2026-10-05
        span.dataset.lowStockSource = 'd'; // opaque (best-seller-collection) — neutralized; cae → 'best'
        _applyBadgePosition(span, _badgePositionFromConfig());
        span.style.pointerEvents = 'none';
        var anchor = card.querySelector('.product-card__figure') || card;
        var cs = window.getComputedStyle(anchor);
        if (cs && cs.position === 'static') anchor.style.position = 'relative';
        anchor.appendChild(span);
        if (handle) {
            _badgedHandles.add(handle);
            // Cross-collection persistence: record the handle in engine
            // state so applyPersistedBestSellerBadges() can re-badge it
            // on later page loads.
            _recordBestSellerHandleInState(handle);
            // Bypass enabler: when the shopper later enters this product's
            // PDP, the engine's _bestSellerExtraLifecyclesAllowed reads
            // sessionStorage['__bestSellerArrivals'] and grants the
            // extraLifecyclesPerProduct slot. Without this write, the
            // bypass was a dead reader.
            _markBestSellerArrivalForBypass(handle);
        }

        // No toast here. _addBadge runs on every page load via
        // _applyPersistedBestSellerBadges replay, so emitting a toast
        // here would spam on every navigation. The "fresh activation"
        // toast lives in fetchCollectionBestSeller (via
        // _fireFreshActivationToast) and only fires when a new best-
        // seller is genuinely picked, not when an existing one is
        // re-stamped from persisted state.
    }

    // Best-seller is a NEW-USER signal; the returning-user flow CANCELS it
    // (predicted-next replaces it). The flow gate (user-flow-gate.js) resolves
    // window.__userFlow asynchronously, AFTER this file's run(), so we defer the
    // best-seller decision until the flow is known, then activate only for
    // non-returning users. Fires the callback once (already-resolved, the
    // SE_userFlowReady event, or a 4s fallback that assumes new-user).
    function _whenFlowKnown(cb) {
        try {
            if (typeof window !== 'undefined' && window.__userFlow) { cb(window.__userFlow); return; }
            var done = false;
            var fire = function () { if (done) return; done = true; cb((typeof window !== 'undefined' && window.__userFlow) || 'new-user'); };
            window.addEventListener('SE_userFlowReady', fire, { once: true });
            setTimeout(fire, 4000);
        } catch (e) { try { cb('new-user'); } catch (e2) {} }
    }

    function run() {
        // RETURNING-USER flow CANCELS best-seller ENTIRELY (predicted-next takes its
        // place). This used to gate only the new-activation FETCH (below), while the
        // persisted-badge re-apply + the lifecycle→cascade bridge ran on EVERY page —
        // so prior best-seller LOW ON STOCK badges (and cascades off the returning
        // predicted-next lifecycles) leaked into the RETURNING grid, with NO toast
        // (no new activation fired). User rule: NO best-seller anything in returning.
        // So the WHOLE body now runs inside the flow gate and bails for returning.
        // (_whenFlowKnown fires synchronously when __userFlow is already resolved —
        // usually true by the time run() fires after engine-ready — so non-returning
        // pages keep their fast persisted-badge re-apply.)
        _whenFlowKnown(function (flow) {
        if (flow === 'returning-user') return;

        // ALWAYS re-apply persisted badges first -- runs on every page
        // load (collection / search / homepage / PDP) so a best-seller
        // activation made on Collection A keeps showing wherever that
        // product appears later. Idempotent + cheap (Set+DOM dedup).
        _applyPersistedBestSellerBadges();
        // Also re-mark __bestSellerArrivals for the persisted handles so
        // PDP entries from a NEW tab (where sessionStorage is fresh but
        // localStorage / group state knows about prior best-seller
        // activations) still get the bypass.
        _persistedBestSellerHandles().forEach(_markBestSellerArrivalForBypass);

        // BRIDGE: engine-driven variant lifecycles → body_html cascade.
        // When the shopper picks a variant on a bundle PDP, the engine
        // creates a lifecycle keyed under the BUNDLE's handle (e.g.
        // `magnetix-bundle-multicam_<variantId>`). The engine's own
        // catalog pass only propagates FORWARD via BUNDLE_COMPONENT_MAP
        // (component → bundles) and doesn't know how to reverse-cascade
        // from a bundle handle to its first component when the bundle
        // isn't in the static map (Magnetix bundles aren't). Without
        // this bridge, activating a Magnetix Bundle Multicam lifecycle
        // doesn't propagate to "Magnetix Battle Belt" on the same
        // collection page.
        //
        // We iterate active engine lifecycles, take each unique handle,
        // and fire BOTH cascade directions (forward + reverse). Standalone
        // products parse to null in `_bundleCompositionFor` so the no-op
        // cost is one cached fetch + one parse.
        try {
            var lifecycles = (window.SE_Engine && window.SE_Engine.state && window.SE_Engine.state.lifecycles) || {};
            var seenLcHandles = Object.create(null);
            for (var lk in lifecycles) {
                if (!Object.prototype.hasOwnProperty.call(lifecycles, lk)) continue;
                // Lifecycle keys are either `<handle>` or `<handle>_<variantId>`.
                // Slice at the FIRST underscore to recover the product handle
                // (Shopify handles can't contain `_` so this is unambiguous).
                var underscoreAt = lk.indexOf('_');
                var lcHandle = underscoreAt === -1 ? lk : lk.slice(0, underscoreAt);
                if (!lcHandle || seenLcHandles[lcHandle]) continue;
                seenLcHandles[lcHandle] = true;
                (function (h) {
                    try {
                        Promise.resolve().then(function () { return _cascadeForwardFromComponent(h); }).catch(function () {});
                        Promise.resolve().then(function () { return _cascadeReverseFromBundle(h); }).catch(function () {});
                    } catch (e) {}
                })(lcHandle);
            }
        } catch (e) {}

        var id = window.__currentCollectionId;
        if (!id) return;
        if (_haveSeen(id)) return;
        _markSeen(id);
        // Activation mode gate: in 'first-collection-only' (the default), once
        // any best-seller has been activated for this shopper's group, stop
        // fetching new ones. Group state is restored on identify via session match,
        // so a family member's prior activation also gates this device.
        // 'every-collection' = legacy behavior (one per visited collection).
        if (_activationModeFromPanel() === 'first-collection-only'
            && _hasAnyBestSellerActivation()) {
            return;
        }
        // New-activation fetch — reached only for non-returning (the entire run()
        // body is inside the returning-bail flow gate opened at the top).
        fetchCollectionBestSeller(id);
        }); // end outer _whenFlowKnown (returning-user bailed at the top)
    }

    // Defer run() until the main engine has populated its state from
    // localStorage. Without this wait, run() can fire on DOMContentLoaded
    // BEFORE agb-variant-extension.js's deferred/module init has run --
    // _hasAnyBestSellerActivation() then reads window.SE_Engine as
    // undefined, returns false, and the gate lets a duplicate fetch
    // through on every collection visit (the bug the user reported).
    //
    // Readiness signal: window.SE_Engine exists AND its .state is an
    // object. State is loaded synchronously by the engine constructor,
    // so the moment .state is set, the gate can read the persisted
    // bestSellerCollections / bestSellerHandles populated by prior
    // activations in this browser.
    //
    // Poll cadence: 50ms × 100 attempts = 5s ceiling, then fall through
    // and run anyway so the badge re-apply path still runs on pages
    // where the engine genuinely isn't loaded (defensive fallback).
    function _engineGateReady() {
        return !!(window.SE_Engine && window.SE_Engine.state
            && typeof window.SE_Engine.state === 'object');
    }

    function _runWhenEngineReady() {
        if (_engineGateReady()) { run(); return; }
        var attempts = 0;
        var MAX_ATTEMPTS = 100;
        var iv = setInterval(function () {
            attempts++;
            if (_engineGateReady() || attempts >= MAX_ATTEMPTS) {
                clearInterval(iv);
                run();
            }
        }, 50);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _runWhenEngineReady);
    } else {
        _runWhenEngineReady();
    }

    // Exposed for manual DevTools testing.
    window.fetchCollectionBestSeller = fetchCollectionBestSeller;
    // Called by the engine's _restoreState after session match group recovery,
    // so the badge reflects the restored bestSellerCollections entry even
    // when state arrived AFTER our initial run().
    window.__reapplyBestSellerForCurrentCollection = reapplyBestSellerForCurrentCollection;
})();
